module.exports = __webpack_public_path__ + "img/blank-profile-picture_100px.46c19eee.png";